import type FolderTreeViewStateStore from './schema/FolderTreeViewStateStore';
import type MailFolderNodeViewState from './schema/MailFolderNodeViewState';
import { createStore } from 'owa-satcheljs';
import { getShouldOverrideToSortBySizeBasedOnURL } from '../utils/getShouldOverrideToSortBySizeBasedOnURL';

// Import mutators so they are initialized at the same time as the store
import '../mutators/updateFolderCountsMutator';

const initialFolderTreeViewStateStore: FolderTreeViewStateStore = {
    folderNodeViewStates: new Map<string, MailFolderNodeViewState>([]),
    contextMenuState: null,
    folderTextFieldViewState: null,
    isDraggedOver: false,
    withContextMenuFolderId: null,
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getShouldOverrideToSortBySizeBasedOnURL called at module scope is not allowed. This may cause unwanted side effects. */
    shouldOverrideToSortBySizeBasedOnURL: getShouldOverrideToSortBySizeBasedOnURL(),
};

export const getStore: () => FolderTreeViewStateStore = createStore<FolderTreeViewStateStore>(
    'folderViewState',
    initialFolderTreeViewStateStore
);
